import { logError } from 'calling-error-reporting/report/error';
import updateThirdPartySubject from 'calling-global-api/methods/updateThirdPartySubject';
import { getObjectId, getObjectTypeId, getPhoneNumberProperties, getPropertyName } from 'calling-lifecycle-internal/callees/operators/calleesOperators';
import { useMemo } from 'react';
// @ts-expect-error not typed

import { isSucceeded } from '../../async-data/operators/statusComparators';
import { hasCallableRecords } from '../../callees/utils/calleeOperators';
import { getIn } from '../../utils/getIn';
import { TICKET_OBJECT_TYPE_ID } from '../constants/ObjectTypeIds';
import PublicCallingApi from './PublicCallingApi';
import { ThirdPartySettingsNumbersHelpDesk } from './ThirdPartySettingsNumbersHelpDesk';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import ProviderName from './ProviderName';
import ChangeProviderButtonWrapper from './ChangeProviderButtonWrapper';
import { THIRD_PARTY_HELP_DESK_POPOVER } from 'calling-integration-sdk-support/viewport/constants/changeProviderButtonLocations';
import { getHasMultipleProviders } from '../../callees/utils/getHasMultipleProviders';
import { triggerThirdPartyOutboundCall } from 'calling-ui-library/calling-remote-redesign/utils/triggerThirdPartyOutboundCall';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ThirdPartyHelpDeskPopover = props => {
  const {
    subjectId,
    calleeOmnibusResult,
    selectedCallProvider,
    calleeOmnibusStatus,
    gates = []
  } = props;
  const calleesData = getIn(['callableObjectAndAssociations'], calleeOmnibusResult);
  const callingProviders = getIn(['installedCallingSettings', 'installedCallingApplications'], calleeOmnibusResult, []);
  const hasMultipleProviders = useMemo(() => getHasMultipleProviders({
    installedCallingApplicationsLength: callingProviders.length,
    fromNumbers: getIn(['phoneNumbers'], calleeOmnibusResult, {}),
    isHubSpotEnabled: getIn(['hubspotCallingEnabled'], calleeOmnibusResult, false)
  }), [callingProviders, calleeOmnibusResult]);
  const shouldShowProviderSwitching = selectedCallProvider && hasMultipleProviders;
  const hasRecords = useMemo(() => hasCallableRecords(calleesData), [calleesData]);
  const renderNoCalleesMessage = () => {
    return null;
    // TODO: Implement NoCalleesPrompt in CALL-6009
    // return (
    //   <NoCalleesPrompt
    //     subjectId={Number(subjectId)}
    //     objectTypeId={objectTypeId}
    //     shouldShowAddNumber={false}
    //   />
    // );
  };
  const renderCallees = () => {
    const {
      appIdentifier,
      isKnownVisitor,
      visitorPhoneNumber,
      threadId
    } = props;
    const startOutboundCall = ({
      numberIdentifier,
      callableObject
    }) => {
      try {
        const updateSubject = window.hsCalling && typeof window.hsCalling.updateThirdPartySubject === 'function' ? window.hsCalling.updateThirdPartySubject : updateThirdPartySubject;
        updateSubject({
          objectId: Number(subjectId) || 0,
          objectTypeId: TICKET_OBJECT_TYPE_ID,
          threadId: Number(threadId) || 0
        });
      } catch (e) {
        logError({
          error: e
        });
      }
      try {
        const phoneNumberProperties = getPhoneNumberProperties(callableObject);
        const numberPropertyName = getPropertyName(numberIdentifier);
        if (!selectedCallProvider) {
          return;
        }
        triggerThirdPartyOutboundCall({
          objectId: Number(getObjectId(callableObject)),
          objectTypeId: getObjectTypeId(callableObject),
          numberPropertyName,
          gates,
          selectedCallProvider,
          phoneNumberProperties,
          threadId: Number(threadId) || 0
        });
      } catch (e) {
        logError({
          error: e
        });
      }
    };
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(PublicCallingApi, {}), !isSucceeded(calleeOmnibusStatus) || hasRecords || visitorPhoneNumber ? /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "column",
        "data-selenium-test": "call-settings-numbers-options",
        "data-test-id": "call-settings-numbers-options",
        children: [/*#__PURE__*/_jsx(ThirdPartySettingsNumbersHelpDesk, {
          appIdentifier: appIdentifier,
          defaultFromNumber: undefined,
          visitorPhoneNumber: visitorPhoneNumber,
          isKnownVisitor: isKnownVisitor,
          calleesData: calleesData,
          startOutboundCall: startOutboundCall
        }), shouldShowProviderSwitching && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(ProviderName, {
            selectedCallProvider: selectedCallProvider
          }), /*#__PURE__*/_jsx(ChangeProviderButtonWrapper, {
            providerName: selectedCallProvider.name,
            location: THIRD_PARTY_HELP_DESK_POPOVER,
            gates: gates
          })]
        })]
      }) : renderNoCalleesMessage()]
    });
  };
  return /*#__PURE__*/_jsx(View, {
    maxInlineSize: "615px",
    children: renderCallees()
  });
};